import { Inject, Injectable, InjectionToken } from '@angular/core';

import { TokenStoreService } from './tokenstore.service';

export const ESTENSA_MODULE_TOKEN_SERVICE = new InjectionToken('estensa.module.token.service');

export interface ITokenService {
    readonly accessToken: string;
}

@Injectable({
    providedIn: 'root',
})
export class InMemoryTokenStore implements TokenStoreService {
    constructor(@Inject(ESTENSA_MODULE_TOKEN_SERVICE) private estensaModuleTokenService: ITokenService) {}

    getToken() {
        return this.estensaModuleTokenService.accessToken;
    }
}
